import { render, staticRenderFns } from "./Phonenumber.vue?vue&type=template&id=3371cb07&scoped=true&"
import script from "./Phonenumber.vue?vue&type=script&lang=ts&"
export * from "./Phonenumber.vue?vue&type=script&lang=ts&"
import style0 from "./Phonenumber.vue?vue&type=style&index=0&id=3371cb07&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3371cb07",
  null
  
)

export default component.exports